/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Secret_Instructions_Access_CInputs */

const en_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Links & Access Codes`)
};

const es_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrucciones secretas / Códigos de acceso`)
};

const fr_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions secrètes / Codes d'accès`)
};

const de_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geheime Anweisungen / Zugangscodes`)
};

const ja_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秘密の手順 / アクセスコード`)
};

const zh_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保密说明 / 访问代码`)
};

const ar_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعليمات سرية / رموز وصول`)
};

const id_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan Pribadi & Kode Akses`)
};

const it_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruzioni Segrete / Codici di Accesso`)
};

const ru_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Секретные инструкции / Коды доступа`)
};

const pt_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruções Secretas / Códigos de Acesso`)
};

const ko_secret_instructions_access_c = /** @type {(inputs: Secret_Instructions_Access_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀 지침 / 액세스 코드`)
};

/**
* | output |
* | --- |
* | "Private Links & Access Codes" |
*
* @param {Secret_Instructions_Access_CInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const secret_instructions_access_c = /** @type {((inputs?: Secret_Instructions_Access_CInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Secret_Instructions_Access_CInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_secret_instructions_access_c(inputs)
	if (locale === "es") return es_secret_instructions_access_c(inputs)
	if (locale === "fr") return fr_secret_instructions_access_c(inputs)
	if (locale === "de") return de_secret_instructions_access_c(inputs)
	if (locale === "ja") return ja_secret_instructions_access_c(inputs)
	if (locale === "zh") return zh_secret_instructions_access_c(inputs)
	if (locale === "ar") return ar_secret_instructions_access_c(inputs)
	if (locale === "id") return id_secret_instructions_access_c(inputs)
	if (locale === "it") return it_secret_instructions_access_c(inputs)
	if (locale === "ru") return ru_secret_instructions_access_c(inputs)
	if (locale === "pt") return pt_secret_instructions_access_c(inputs)
	return ko_secret_instructions_access_c(inputs)
});